import { defineFetch } from 'resift';
import * as Types from 'pages/Pages/typings';

export default defineFetch({
  displayName: 'entity types fetch',
  make: (entityTypeId: string) => ({
    key: [],
    request: ({ name, description, isActive, settings }: Types.UpdateEntity) => ({ http }: any) =>
      http({
        method: 'PUT',
        route: `/entity-types/${entityTypeId}`,
        data: {
          name,
          description,
          isActive,
          settings,
        },
      }),
  }),
});
